const state = {
  visible: false,
  // WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK
  // WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_NOTE
  // WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_CATALOG
  // WORKBENCH_SIDEBAR_OUTLINE_NOTE
  // WORKBENCH_SIDEBAR_CATALOG_MORE
  // WORKBENCH_SIDEBAR_OUTLINE_MORE
  // WORKBENCH_SIDEBAR_OPENED_MORE
  // WORKBENCH_SIDEBAR_OPENED_ITEM
  // SIDEBAR_TOOLS
  type: '',
  data: {},
  cutData: {}
}

const getters = {
  visible (state) {
    return state.visible
  },
  isWorkbenchSidebarCatalogNotebook (state) {
    return state.type === 'WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK'
  },
  isWorkbenchSidebarCatalogNotebookNote (state) {
    return state.type === 'WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_NOTE'
  },
  isWorkbenchSidebarCatalogNotebookCatalog (state) {
    return state.type === 'WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_CATALOG'
  },
  isWorkbenchSidebarOutlineNote (state) {
    return state.type === 'WORKBENCH_SIDEBAR_OUTLINE_NOTE'
  },
  isWorkbenchSidebarOutlineMore (state) {
    return state.type === 'WORKBENCH_SIDEBAR_OUTLINE_MORE'
  },
  isWorkbenchSidebarCatalogMore (state) {
    return state.type === 'WORKBENCH_SIDEBAR_CATALOG_MORE'
  },
  isWorkbenchSidebarOpenedMore (state) {
    return state.type === 'WORKBENCH_SIDEBAR_OPENED_MORE'
  },
  isWorkbenchSidebarOpenedItem (state) {
    return state.type === 'WORKBENCH_SIDEBAR_OPENED_ITEM'
  },
  isSidebarTools (state) {
    return state.type === 'SIDEBAR_TOOLS'
  },
  data (state) {
    return state.data
  },
  cutData (state) {
    return state.cutData
  }
}

const mutations = {
  SET_VISIBLE (state, visible) {
    state.visible = visible
  },
  SET_TYPE (state, type) {
    state.type = type
  },
  SET_DATA (state, data) {
    state.data = data
  },
  SET_CUT_DATA (state, data) {
    state.cutData = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
